/**
 * isura_application.tsx — GIZA app bootstrap for Isura.
 *
 * Default: Stable landing page (App).
 * Preview: Pass ?v=2 to preview the modernized Dun-integrated Isura.
 *
 * @module GIZA/isura/src/isura_application
 */

import { StrictMode, Suspense, lazy } from 'react';
import App from './app/App';
import './styles/index.css';

const ModernIsura = lazy(() => import('./modern/ModernIsura'));

export function IsuraApplication() {
  const isV2 =
    typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('v') === '2';

  return (
    <StrictMode>
      {isV2 ? (
        <Suspense fallback={<div className="min-h-screen bg-[#fefeff]" />}>
          <ModernIsura />
        </Suspense>
      ) : (
        <App />
      )}
    </StrictMode>
  );
}
